import { DefaultButton } from "..";
import GoogleLogo from "../../img/icons/Google__G__logo.svg";

export default function GoogleLoginWidget(props) {
    const { text = "Sign in with Google", onClick } = props;
    return (
        <DefaultButton
            text={text}
            onClick={onClick}
            preIcon={
                <img
                    src={GoogleLogo}
                    width="15px"
                />
            }
        />
    );
}